import { projectApiUrl } from "API/urls/project.api";
import { axiosInstance } from "configs/axios";

export const fetchProjectsApi = async (payload) => {
  try {
    const response = await axiosInstance.post(projectApiUrl.getProjects, {
      ...payload,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
